<!-- 
<div class="overlay active"
     style="position:fixed"
     *ngIf="false"></div>-->

<div swqModal class="modal slide-left container wsection" [class.active]="swqModalStatusModel.swqModalIsOpen" id="divCommonHeader"></div>

<ng-template sw-discard-host></ng-template>

<!-- <div *ngIf="false"><webc-login layout="modal" autogenerated-password="true" product-id="2"></webc-login></div> -->
<div swProcess class="container wsection captchaModel" id="section_wise_container"></div>
